var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 36,
    viewBox: "0 0 30 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.47037 35.2499C2.89477 35.2489 2.32935 35.098 1.82975 34.8121C0.704746 34.1746 0.00537109 32.9371 0.00537109 31.5937V4.40617C0.00537109 3.05898 0.704746 1.82523 1.82975 1.18773C2.34125 0.893768 2.92232 0.742595 3.51224 0.750017C4.10215 0.757438 4.67924 0.923181 5.18318 1.22992L28.4191 15.1387C28.9034 15.4423 29.3026 15.864 29.5793 16.3641C29.856 16.8642 30.0012 17.4265 30.0012 17.998C30.0012 18.5696 29.856 19.1318 29.5793 19.632C29.3026 20.1321 28.9034 20.5538 28.4191 20.8574L5.17943 34.7699C4.66371 35.0817 4.07301 35.2476 3.47037 35.2499V35.2499Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.cd6c595e4f44a5c60a9645f9e1d80b9f.svg";
export { ForwardRef as ReactComponent };